 
// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { Pie, PieChart, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import axios from "axios";
// import { useAuth } from '../../context/auth';
// import { useNavigate } from 'react-router-dom';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { FiRefreshCcw } from 'react-icons/fi';
// import '../cssStyle/SimplePieChart.css';

// const SimplePieChart = () => {
//   const [pieData, setPieData] = useState([
//     { name: 'DR (Green)', value: 0, color: '#22c55e', count: 0 },
//     { name: 'UR (Red)', value: 0, color: '#ef4444', count: 0 }
//   ]);
//   const [loading, setLoading] = useState(true);
//   const [totalSymbols, setTotalSymbols] = useState(0);
//   const [totalSignals, setTotalSignals] = useState(0);
//   const [lastUpdated, setLastUpdated] = useState(null);
//   const [currentTime, setCurrentTime] = useState(new Date());
//   const [isRefreshing, setIsRefreshing] = useState(false);
  
//   const intervalRef = useRef(null);
//   const isMountedRef = useRef(true);
  
//   const { getAdminAuthToken } = useAuth();
//   const navigate = useNavigate();
//   const token = getAdminAuthToken();

//   // Real-time clock
//   useEffect(() => {
//     const clockInterval = setInterval(() => {
//       if (isMountedRef.current) {
//         setCurrentTime(new Date());
//       }
//     }, 1000);
    
//     return () => clearInterval(clockInterval);
//   }, []);

//   // Process data - Count last signal for symbols with >=2 signals
//   const processData = useCallback((rawData) => {
//     // Filter only 'second' and 'third' type data
//     const filteredData = [];
//     rawData.forEach(insItem => {
//       if (insItem.data && Array.isArray(insItem.data)) {
//         const filteredTypesData = insItem.data.filter(item => 
//           item.type === 'second' || item.type === 'third'
//         );
//         if (filteredTypesData.length > 0) {
//           filteredData.push({
//             ...insItem,
//             data: filteredTypesData
//           });
//         }
//       }
//     });
    
//     // Group by symbol and collect all entries
//     const symbolMap = new Map();
    
//     filteredData.forEach(insItem => {
//       if (insItem.data && Array.isArray(insItem.data)) {
//         insItem.data.forEach(item => {
//           const percentageValue = parseFloat(item.percentage);
//           if (percentageValue === 0) return;
          
//           const symbol = item.symbol;
//           const category = item.cat;
//           const time = new Date(item.time);
          
//           if (!symbolMap.has(symbol)) {
//             symbolMap.set(symbol, {
//               symbol: symbol,
//               entries: [],
//               lastSignal: null,
//               lastSignalType: null,
//               lastSignalTime: null
//             });
//           }
          
//           const symbolData = symbolMap.get(symbol);
//           symbolData.entries.push({
//             cat: category,
//             time: time,
//             percentage: percentageValue
//           });
//         });
//       }
//     });
    
//     // Process each symbol - get last signal (only if >=2 entries)
//     let drLastSignals = 0;
//     let urLastSignals = 0;
//     let symbolsWithMultipleSignals = 0;
//     let totalSignalsCount = 0;
    
//     for (const [symbol, data] of symbolMap.entries()) {
//       const entryCount = data.entries.length;
//       totalSignalsCount += entryCount;
      
//       // Only consider symbols with at least 2 signals
//       if (entryCount >= 2) {
//         symbolsWithMultipleSignals++;
        
//         // Sort entries by time (newest first)
//         const sortedEntries = [...data.entries].sort((a, b) => b.time - a.time);
//         const lastSignal = sortedEntries[0];
        
//         if (lastSignal && lastSignal.cat) {
//           const isDR = lastSignal.cat.includes('DR');
//           if (isDR) {
//             drLastSignals++;
//           } else {
//             urLastSignals++;
//           }
//         }
//       }
//     }
    
//     // Calculate percentages
//     const totalSignalsConsidered = drLastSignals + urLastSignals;
//     const drPercentage = totalSignalsConsidered > 0 ? (drLastSignals / totalSignalsConsidered) * 100 : 0;
//     const urPercentage = totalSignalsConsidered > 0 ? (urLastSignals / totalSignalsConsidered) * 100 : 0;
    
//     return {
//       pieData: [
//         { name: 'DR (Green)', value: drPercentage, color: '#22c55e', count: drLastSignals },
//         { name: 'UR (Red)', value: urPercentage, color: '#ef4444', count: urLastSignals }
//       ],
//       totalSymbols: symbolsWithMultipleSignals,
//       totalSignals: totalSignalsCount,
//       drCount: drLastSignals,
//       urCount: urLastSignals
//     };
//   }, []);

//   const fetchData = async (showToastMsg = false, isSilent = false) => {
//     if (!token) {
//       setLoading(false);
//       if (showToastMsg) toast.error("Please login first");
//       setTimeout(() => navigate('/login'), 2000);
//       return;
//     }

//     // ✅ Only show refreshing indicator for manual refresh
//     if (showToastMsg) {
//       setIsRefreshing(true);
//     }

//     try {
//       const response = await axios.get(
//         "https://api.algocontroller.com/admin_app/getting_admin_analysis",
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );
      
//       const rawData = response.data?.data || [];
//       const processed = processData(rawData);
      
//       if (isMountedRef.current) {
//         setPieData(processed.pieData);
//         setTotalSymbols(processed.totalSymbols);
//         setTotalSignals(processed.totalSignals);
//         setLastUpdated(new Date());
//         setLoading(false);
        
//         // ✅ Only show toast for manual refresh
//         if (showToastMsg) {
//           toast.success(`Data refreshed! ${processed.totalSymbols} symbols analyzed`);
//         }
//       }
//     } catch (err) {
//       console.error("API Error:", err);
//       if (isMountedRef.current) {
//         setLoading(false);
//         if (showToastMsg) toast.error("Failed to fetch data");
//       }
//     } finally {
//       if (showToastMsg) {
//         setTimeout(() => setIsRefreshing(false), 500);
//       }
//     }
//   };

//   // ✅ Auto-refresh every 5 seconds (silent - no loader, no toast)
//   useEffect(() => {
//     isMountedRef.current = true;
    
//     if (!token) {
//       setLoading(false);
//       toast.error("Please login first");
//       setTimeout(() => navigate('/login'), 2000);
//       return;
//     }
    
//     // Initial fetch
//     fetchData(false, true);
    
//     // ✅ Set interval to fetch every 5 seconds (5000 ms)
//     intervalRef.current = setInterval(() => {
//       if (isMountedRef.current && token) {
//         console.log("🔄 Auto-refreshing pie chart...", new Date().toLocaleTimeString());
//         fetchData(false, true); // Silent refresh - no toast, no loader
//       }
//     }, 5000); // 5 seconds
    
//     return () => {
//       isMountedRef.current = false;
//       if (intervalRef.current) {
//         clearInterval(intervalRef.current);
//       }
//     };
//   }, [token]);

//   const handleRefresh = () => {
//     fetchData(true, false);
//   };

//   const formatCurrentTime = () => {
//     return currentTime.toLocaleTimeString('en-US', { 
//       hour: '2-digit', 
//       minute: '2-digit', 
//       second: '2-digit' 
//     });
//   };

//   const CustomTooltip = ({ active, payload }) => {
//     if (active && payload && payload.length) {
//       const data = payload[0].payload;
//       return (
//         <div className="pie-tooltip">
//           <div className="pie-tooltip-header">
//             <span className="pie-tooltip-name">{data.name}</span>
//           </div>
//           <div className="pie-tooltip-stats">
//             <div className="pie-tooltip-row">
//               <span>Percentage:</span>
//               <strong>{data.value.toFixed(1)}%</strong>
//             </div>
//             <div className="pie-tooltip-row">
//               <span>Symbols Count:</span>
//               <strong>{data.count}</strong>
//             </div>
//           </div>
//         </div>
//       );
//     }
//     return null;
//   };

//   if (loading) {
//     return (
//       <div className="pie-chart-loading">
//         <div className="loading-spinner"></div>
//         <p>Loading chart data...</p>
//       </div>
//     );
//   }

//   const totalLastSignals = pieData[0].count + pieData[1].count;

//   return (
//     <div className="simple-pie-chart-container">
//       <ToastContainer 
//         position="top-right"
//         autoClose={2000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss={false}
//         draggable={false}
//         pauseOnHover={false}
//         limit={3}
//       />
      
//       <div className="pie-chart-header">
//         <div className="pie-header-left">
//           <h3>🎯 Last Signal Analysis</h3>
//           <div className="pie-stats-badge">
//             <span className="pie-stat">📊 Symbols: {totalSymbols}</span>
//             <span className="pie-stat">🟢 DR Last: {pieData[0].count}</span>
//             <span className="pie-stat">🔴 UR Last: {pieData[1].count}</span>
//             {/* <span className="pie-stat time">🕐 {formatCurrentTime()}</span> */}
//           </div>
//         </div>
//         <div className="pie-header-right">
//           <button 
//             onClick={handleRefresh} 
//             className={`pie-refresh-btn ${isRefreshing ? 'refreshing' : ''}`} 
//             title="Refresh"
//             disabled={isRefreshing}
//           >
//             <FiRefreshCcw size={14} className={isRefreshing ? 'spin' : ''} />
//           </button>
//         </div>
//       </div>

//       <div className="pie-chart-wrapper">
//         <ResponsiveContainer width="100%" height={400}>
//           <PieChart>
//             <Pie
//               data={pieData}
//               cx="50%"
//               cy="50%"
//               innerRadius={0}
//               outerRadius={150}
//             //   paddingAngle={5}
//               dataKey="value"
//               label={({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
//                 const radius = innerRadius + (outerRadius - innerRadius) * 0.6;
//                 const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
//                 const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
//                 return (
//                   <text 
//                     x={x} 
//                     y={y} 
//                     fill="white" 
//                     textAnchor="middle" 
//                     dominantBaseline="central"
//                     style={{ fontSize: '12px', fontWeight: 'bold' }}
//                   >
//                     {`${(percent * 100).toFixed(0)}%`}
//                   </text>
//                 );
//               }}
//               labelLine={false}
//             >
//               {pieData.map((entry, index) => (
//                 <Cell key={`cell-${index}`} fill={entry.color} />
//               ))}
//             </Pie>
//             <Tooltip content={<CustomTooltip />} />
//             <Legend 
//               verticalAlign="bottom" 
//               align="center"
//               iconType="circle"
//               formatter={(value, entry) => {
//                 const data = pieData.find(d => d.name === value);
//                 return `${value} (${data?.count || 0} symbols - ${data?.value.toFixed(1)}%)`;
//               }}
//               wrapperStyle={{ fontSize: '12px', paddingTop: '20px' }}
//             />
//           </PieChart>
//         </ResponsiveContainer>
//       </div>

//       <div className="pie-chart-footer">
//         <div className="pie-footer-info">
//           <div className="pie-info-card">
//             <span className="pie-info-label">🎯 Analysis Method</span>
//             <span className="pie-info-value">Last signal of symbols with ≥2 total signals</span>
//           </div>
//           <div className="pie-info-card">
//             <span className="pie-info-label">🟢 DR (Green)</span>
//             <span className="pie-info-value">Last signal was positive (DR_SMALL/DR_BIG)</span>
//           </div>
//           <div className="pie-info-card">
//             <span className="pie-info-label">🔴 UR (Red)</span>
//             <span className="pie-info-value">Last signal was negative (UR_SMALL/UR_BIG)</span>
//           </div>
//         </div>
//         <div className="pie-footer-note">
//           <span>✅ Only symbols with ≥2 total signals are considered</span>
//           <span>🔄 Auto-refreshes every 5 seconds</span>
//           <span>💡 Last signal determines the final outcome</span>
//         </div>
//       </div>

//       <style jsx>{`
//         .spin {
//           animation: spin 0.5s linear infinite;
//         }
        
//         @keyframes spin {
//           from {
//             transform: rotate(0deg);
//           }
//           to {
//             transform: rotate(360deg);
//           }
//         }
        
//         .pie-refresh-btn.refreshing {
//           opacity: 0.7;
//           cursor: not-allowed;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default SimplePieChart;





import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Pie, PieChart, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import axios from "axios";
import { useAuth } from '../../context/auth';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FiRefreshCcw } from 'react-icons/fi';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import '../cssStyle/SimplePieChart.css';

const SimplePieChart = () => {
  const [showChart, setShowChart] = useState(true);
  const [pieData, setPieData] = useState([
    { name: 'DR (Green)', value: 0, color: '#22c55e', count: 0 },
    { name: 'UR (Red)', value: 0, color: '#ef4444', count: 0 }
  ]);
  const [loading, setLoading] = useState(true);
  const [totalSymbols, setTotalSymbols] = useState(0);
  const [totalSignals, setTotalSignals] = useState(0);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  const intervalRef = useRef(null);
  const isMountedRef = useRef(true);
  
  const { getAdminAuthToken } = useAuth();
  const navigate = useNavigate();
  const token = getAdminAuthToken();

  // Real-time clock
  useEffect(() => {
    const clockInterval = setInterval(() => {
      if (isMountedRef.current) {
        setCurrentTime(new Date());
      }
    }, 1000);
    
    return () => clearInterval(clockInterval);
  }, []);

  // Process data - Count last signal for symbols with >=2 signals
  const processData = useCallback((rawData) => {
    // Filter only 'second' and 'third' type data
    const filteredData = [];
    rawData.forEach(insItem => {
      if (insItem.data && Array.isArray(insItem.data)) {
        const filteredTypesData = insItem.data.filter(item => 
          item.type === 'second' || item.type === 'third'
        );
        if (filteredTypesData.length > 0) {
          filteredData.push({
            ...insItem,
            data: filteredTypesData
          });
        }
      }
    });
    
    // Group by symbol and collect all entries
    const symbolMap = new Map();
    
    filteredData.forEach(insItem => {
      if (insItem.data && Array.isArray(insItem.data)) {
        insItem.data.forEach(item => {
          const percentageValue = parseFloat(item.percentage);
          if (percentageValue === 0) return;
          
          const symbol = item.symbol;
          const category = item.cat;
          const time = new Date(item.time);
          
          if (!symbolMap.has(symbol)) {
            symbolMap.set(symbol, {
              symbol: symbol,
              entries: [],
              lastSignal: null,
              lastSignalType: null,
              lastSignalTime: null
            });
          }
          
          const symbolData = symbolMap.get(symbol);
          symbolData.entries.push({
            cat: category,
            time: time,
            percentage: percentageValue
          });
        });
      }
    });
    
    // Process each symbol - get last signal (only if >=2 entries)
    let drLastSignals = 0;
    let urLastSignals = 0;
    let symbolsWithMultipleSignals = 0;
    let totalSignalsCount = 0;
    
    for (const [symbol, data] of symbolMap.entries()) {
      const entryCount = data.entries.length;
      totalSignalsCount += entryCount;
      
      // Only consider symbols with at least 2 signals
      if (entryCount >= 2) {
        symbolsWithMultipleSignals++;
        
        // Sort entries by time (newest first)
        const sortedEntries = [...data.entries].sort((a, b) => b.time - a.time);
        const lastSignal = sortedEntries[0];
        
        if (lastSignal && lastSignal.cat) {
          const isDR = lastSignal.cat.includes('DR');
          if (isDR) {
            drLastSignals++;
          } else {
            urLastSignals++;
          }
        }
      }
    }
    
    // Calculate percentages
    const totalSignalsConsidered = drLastSignals + urLastSignals;
    const drPercentage = totalSignalsConsidered > 0 ? (drLastSignals / totalSignalsConsidered) * 100 : 0;
    const urPercentage = totalSignalsConsidered > 0 ? (urLastSignals / totalSignalsConsidered) * 100 : 0;
    
    return {
      pieData: [
        { name: 'DR (Green)', value: drPercentage, color: '#22c55e', count: drLastSignals },
        { name: 'UR (Red)', value: urPercentage, color: '#ef4444', count: urLastSignals }
      ],
      totalSymbols: symbolsWithMultipleSignals,
      totalSignals: totalSignalsCount,
      drCount: drLastSignals,
      urCount: urLastSignals
    };
  }, []);

  const fetchData = async (showToastMsg = false, isSilent = false) => {
    if (!token) {
      setLoading(false);
      if (showToastMsg) toast.error("Please login first");
      setTimeout(() => navigate('/login'), 2000);
      return;
    }

    if (showToastMsg) {
      setIsRefreshing(true);
    }

    try {
      const response = await axios.get(
        "https://api.algocontroller.com/admin_app/getting_admin_analysis",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      
      const rawData = response.data?.data || [];
      const processed = processData(rawData);
      
      if (isMountedRef.current) {
        setPieData(processed.pieData);
        setTotalSymbols(processed.totalSymbols);
        setTotalSignals(processed.totalSignals);
        setLastUpdated(new Date());
        setLoading(false);
        
        if (showToastMsg) {
          toast.success(`Data refreshed! ${processed.totalSymbols} symbols analyzed`);
        }
      }
    } catch (err) {
      console.error("API Error:", err);
      if (isMountedRef.current) {
        setLoading(false);
        if (showToastMsg) toast.error("Failed to fetch data");
      }
    } finally {
      if (showToastMsg) {
        setTimeout(() => setIsRefreshing(false), 500);
      }
    }
  };

  // Auto-refresh every 5 seconds (silent)
  useEffect(() => {
    isMountedRef.current = true;
    
    if (!token) {
      setLoading(false);
      toast.error("Please login first");
      setTimeout(() => navigate('/login'), 2000);
      return;
    }
    
    fetchData(false, true);
    
    intervalRef.current = setInterval(() => {
      if (isMountedRef.current && token) {
        console.log("🔄 Auto-refreshing pie chart...", new Date().toLocaleTimeString());
        fetchData(false, true);
      }
    }, 5000);
    
    return () => {
      isMountedRef.current = false;
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [token]);

  const handleRefresh = () => {
    fetchData(true, false);
  };

  const toggleChart = () => {
    setShowChart(!showChart);
  };

  const formatCurrentTime = () => {
    return currentTime.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit' 
    });
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="pie-tooltip">
          <div className="pie-tooltip-header">
            <span className="pie-tooltip-name">{data.name}</span>
          </div>
          <div className="pie-tooltip-stats">
            <div className="pie-tooltip-row">
              <span>Percentage:</span>
              <strong>{data.value.toFixed(1)}%</strong>
            </div>
            <div className="pie-tooltip-row">
              <span>Symbols Count:</span>
              <strong>{data.count}</strong>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  if (loading) {
    return (
      <div className="pie-chart-loading">
        <div className="loading-spinner"></div>
        <p>Loading chart data...</p>
      </div>
    );
  }

  const totalLastSignals = pieData[0].count + pieData[1].count;

  return (
    <div className="simple-pie-chart-container">
      <ToastContainer 
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        limit={3}
      />
      
      {/* Header with Toggle */}
      <div className="pie-chart-header" onClick={toggleChart} style={{ cursor: 'pointer' }}>
        <div className="pie-header-left">
          <h3>🎯 Last Signal Analysis</h3>
          <div className="pie-stats-badge">
            <span className="pie-stat">📊 Symbols: {totalSymbols}</span>
            <span className="pie-stat">🟢 DR Last: {pieData[0].count}</span>
            <span className="pie-stat">🔴 UR Last: {pieData[1].count}</span>
          </div>
        </div>
        <div className="pie-header-right">
          <button 
            onClick={(e) => {
              e.stopPropagation();
              handleRefresh();
            }} 
            className={`pie-refresh-btn ${isRefreshing ? 'refreshing' : ''}`} 
            title="Refresh"
            disabled={isRefreshing}
          >
            <FiRefreshCcw size={14} className={isRefreshing ? 'spin' : ''} />
          </button>
          <span className="pie-toggle-icon">
            {showChart ? <IoIosArrowUp size={18} /> : <IoIosArrowDown size={18} />}
          </span>
        </div>
      </div>

      {/* Chart Content - Toggle */}
      {showChart && (
        <>
          <div className="pie-chart-wrapper">
            <ResponsiveContainer width="100%" height={400}>
              <PieChart>
                <Pie
                  data={pieData}
                  cx="50%"
                  cy="50%"
                  innerRadius={0}
                  outerRadius={150}
                  dataKey="value"
                  label={({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
                    const radius = innerRadius + (outerRadius - innerRadius) * 0.6;
                    const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
                    const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
                    return (
                      <text 
                        x={x} 
                        y={y} 
                        fill="white" 
                        textAnchor="middle" 
                        dominantBaseline="central"
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                      >
                        {`${(percent * 100).toFixed(0)}%`}
                      </text>
                    );
                  }}
                  labelLine={false}
                >
                  {pieData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
                <Legend 
                  verticalAlign="bottom" 
                  align="center"
                  iconType="circle"
                  formatter={(value, entry) => {
                    const data = pieData.find(d => d.name === value);
                    return `${value} (${data?.count || 0} symbols - ${data?.value.toFixed(1)}%)`;
                  }}
                  wrapperStyle={{ fontSize: '12px', paddingTop: '20px' }}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div className="pie-chart-footer">
            <div className="pie-footer-info">
              <div className="pie-info-card">
                <span className="pie-info-label">🎯 Analysis Method</span>
                <span className="pie-info-value">Last signal of symbols with ≥2 total signals</span>
              </div>
              <div className="pie-info-card">
                <span className="pie-info-label">🟢 DR (Green)</span>
                <span className="pie-info-value">Last signal was positive (DR_SMALL/DR_BIG)</span>
              </div>
              <div className="pie-info-card">
                <span className="pie-info-label">🔴 UR (Red)</span>
                <span className="pie-info-value">Last signal was negative (UR_SMALL/UR_BIG)</span>
              </div>
            </div>
            <div className="pie-footer-note">
              <span>✅ Only symbols with ≥2 total signals are considered</span>
              <span>🔄 Auto-refreshes every 5 seconds</span>
              <span>💡 Last signal determines the final outcome</span>
            </div>
          </div>
        </>
      )}

      <style jsx>{`
        .spin {
          animation: spin 0.5s linear infinite;
        }
        
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        
        .pie-refresh-btn.refreshing {
          opacity: 0.7;
          cursor: not-allowed;
        }
        
        .pie-toggle-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 8px;
          color: #6b7280;
        }
        
        .pie-chart-header {
          cursor: pointer;
          transition: all 0.2s ease;
        }
        
        .pie-chart-header:hover {
          background-color: rgba(0, 0, 0, 0.02);
        }
        
        .pie-header-right {
          display: flex;
          align-items: center;
          gap: 8px;
        }
      `}</style>
    </div>
  );
};

export default SimplePieChart;